import animation from './animation';
import button from './button';
import colors from './colors';
import etc from './etc';
import form from './form';
import layout from './layout';
import typography from './typography';

export default {
  animation,
  button,
  etc,
  colors,
  form,
  layout,
  typography,
};
